import { Component, Input, OnInit } from '@angular/core';
import { ValdnWidgetsDateModel } from 'src/app/models/widgets-validation/valdn-widgets-date.model';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: '[appValdnWidgetsDate]',
  templateUrl: './valdn-widgets-date.component.html',
  styleUrls: ['./valdn-widgets-date.component.scss']
})
export class ValdnWidgetsDateComponent implements OnInit {
  @Input() data: ValdnWidgetsDateModel = new ValdnWidgetsDateModel();

  fields: string[] = [];
  left: string = '';
  right: string = '';
  condition: string = '<=';

  constructor(private widgetsService: WidgetsService) {
  }

  ngOnInit(): void {
    this.fields = this.widgetsService.getAllFieldsOfType("datepicker");
  }

  onSelected($event:any) {
    // this.logger.log(this.data.template);    
    this.data.template = "{\n        \"name\": \"date\",\n        \"options\": {\n          \"data\": {\n            \"condition\": \""+
      this.condition+"\",\n            \"left\": \""+
      this.left+"\",\n            \"right\": \""+
      this.right+"\"\n          },\n          \"errorPath\": \""+
      this.left+"\"\n        }\n      }"
  }
}
